import {
  JSONApiRelation,
  JSONApiRelationList,
  JSONApiResourceBase,
} from '../interfaces/JSONApi.js'
import { BaseEvents } from './Events.js'

export enum CallEndedBy {
  SYSTEM = 'SYSTEM',
  USER = 'USER',
  THIRD_PARTY = 'THIRD_PARTY',
}

export enum CallType {
  campaignListCalls = 'campaignListCalls',
  campaignInboundCalls = 'campaignInboundCalls',
  customCalls = 'customCalls',
  voicemailCallback = 'voicemailCallback',
  conferenceCalls = 'conferenceCalls',
  extensionCalls = 'extensionCalls',
}

export interface AsteriskChannel {
  type: 'channels'
  id: string
  attributes: {
    channelName: string
    asteriskServerIp: string
  }
}

export interface CallEvent {
  eventId: string
  type: 'calls'
  op: 'replace' | 'add'
  id: number
  data: {
    callType?: string
    organizationId?: number
    userId?: number
    extensionId?: number
    parentId?: number
    queueId?: number
    trunkId?: number
    campaignId?: number
    campaignListId?: number
    campaignListRecordId?: number
    campaignListRecordContactDetailId?: number
    campaignDispositionId?: number
    inbound?: boolean
    killed?: boolean
    killReason?: string
    sipCode?: string
    number?: string
    additionalData?: any
    callStatus?: string
    billingSeconds?: number
    callDuration?: number
    asteriskServerIp?: string
    asteriskChannelId?: string
    recordingFileName?: string
    callEndedBy?: CallEndedBy
    gatewayIp?: string
    gatewayChannelId?: string
    failoverRecordingName?: string
    queueEnteredAt?: string
    transferredAt?: string
    createdAt?: string
    updatedAt?: string
  }
}
export interface CallEvents extends BaseEvents {
  calls: CallEvent
}

export interface Call extends JSONApiResourceBase {
  type: 'calls'
  attributes: {
    legacyId?: number
    callType?: CallType
    inbound?: boolean
    killed?: boolean
    sipCode?: number
    number?: string
    additionalData?: any
    callStatus?: string
    billingSeconds?: number
    callDuration?: number
    asteriskServerIp?: string
    asteriskChannelId?: string
    recordingFileName?: string
    gatewayIp?: string
    gatewayChannelId?: string
    failoverRecordingName?: string
    callEndedBy?: CallEndedBy
    queueEnteredAt?: string
    transferredAt?: string
    createdAt?: string
    updatedAt?: string
    queuedForAgentAt?: string
  }
  meta?: {
    roomCode?: number
  }
  relationships: {
    user?: JSONApiRelation
    trunk?: JSONApiRelation
    organization?: JSONApiRelation
    extension?: JSONApiRelation
    queue?: JSONApiRelation
    campaign?: JSONApiRelation
    campaignList?: JSONApiRelation
    listRecord?: JSONApiRelation
    disposition?: JSONApiRelation
    organizationDisposition?: JSONApiRelation
    campaignListRecordContactDetail?: JSONApiRelation
    parent?: JSONApiRelation
    conferenceCalls?: JSONApiRelationList
  }
}
